import React from 'react';
import { Link } from 'react-router-dom';
import { Mountain, Phone, Mail, MapPin, Instagram, Facebook, Youtube } from 'lucide-react';
import { companyInfo, tourCategories } from '../../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-emerald-900 to-emerald-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="p-2 bg-white/10 rounded-lg">
                <Mountain className="h-8 w-8 text-emerald-400" />
              </div>
              <div>
                <span className="font-bold text-xl text-white">Magic Mountain</span>
                <span className="text-sm block text-emerald-400">Adventures</span>
              </div>
            </Link>
            <p className="text-emerald-200 leading-relaxed">
              {companyInfo.tagline}. Your gateway to unforgettable Himalayan adventures since 2010.
            </p>
            <div className="flex gap-4 mt-6">
              <a href={companyInfo.socialLinks.instagram} target="_blank" rel="noreferrer" 
                 className="p-2 bg-white/10 rounded-lg hover:bg-white/20 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href={companyInfo.socialLinks.facebook} target="_blank" rel="noreferrer"
                 className="p-2 bg-white/10 rounded-lg hover:bg-white/20 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href={companyInfo.socialLinks.youtube} target="_blank" rel="noreferrer"
                 className="p-2 bg-white/10 rounded-lg hover:bg-white/20 transition-colors">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6 text-white">Adventures</h4>
            <ul className="space-y-3">
              {tourCategories.map((cat) => (
                <li key={cat.id}>
                  <Link to={`/${cat.id}`} className="text-emerald-200 hover:text-white transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* More Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-emerald-200 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-emerald-200 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/gallery" className="text-emerald-200 hover:text-white transition-colors">Gallery</Link></li>
              <li><Link to="/contact" className="text-emerald-200 hover:text-white transition-colors">Contact Us</Link></li>
              <li><Link to="/staff" className="text-emerald-200 hover:text-white transition-colors">Staff Portal</Link></li>
              <li><Link to="/reviews" className="text-emerald-200 hover:text-white transition-colors">Reviews</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-6 text-white">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${companyInfo.phone}`} className="flex items-start gap-3 text-emerald-200 hover:text-white transition-colors">
                  <Phone className="h-5 w-5 mt-0.5 flex-shrink-0" />
                  <span>{companyInfo.phone}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${companyInfo.email}`} className="flex items-start gap-3 text-emerald-200 hover:text-white transition-colors">
                  <Mail className="h-5 w-5 mt-0.5 flex-shrink-0" />
                  <span className="break-all">{companyInfo.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-emerald-200">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span>{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-emerald-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-emerald-300 text-sm">
            © {new Date().getFullYear()} Magic Mountain Adventures. All rights reserved.
          </p>
          <p className="text-emerald-400 text-sm">
            Crafted with love in the Himalayas
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
